export default {
  "Movements queue":"Movement queue",
  "Language":"Language",
  "Updated successfully":"Updated successfully",
  "User Settings":"User settings",
  "Exit":"Log out",
  "Warehouse":"Warehouse",
  "Movements history":"Movement history",
  "Stock":"Stock",
  "Masters":"Master data",
  "Machines":"Machines",
  "Positions":"Positions",
  "Containers":"Containers",
  "Families":"Item families",
  "Users":"Users",
  "Admin setings":"Admin settings",
  "Params":"Parameters",
  "Logs":"Activity logs",
  "App settings":"App settings",
  "Waiting":"Waiting",
  "Working":"Working",
  "Communication lost":"Communication lost",
  "Without communication":"Without communication",
  "Name":"Name",
  "User name":"User name",
  "Required":"Required",
  "Old password":"Old password",
  "New password":"New password",
  "The passwords not match":"The passwords not match",
  "Repeat password":"Repeat password",
  "Dark theme":"Dark theme",
  "Setings":"Settings",
  "Are you sure you want to delete machine %s ?":"Are you sure you want to delete machine {machine} ?",
  "family added succefully":"family added successfully",
  "family updated succefully":"family updated succefully",
  "familyId":"Family Identifier",
  "actions":"Action",
  "Machines":"Machines",
  "type":"type",
  "Abbreviation":"Abbreviation",
  "Priority":"Priority",
  "Search":"Search",
  "containerNumber":"Pallet number",
  "width":"Width",
  "height":"Height",
  "large":"Depth",
  "containersType":"Pallet types",
  "ID":"ID",
  "PosX":"Position X",
  "PosY":"Position Y",
  "PosZ":"Position Z",
  "maxDepth":"Max Depth",
  "PositionType":"Position Type",
  "physicalPositions":"Physical Positions",
  "tracks":"Tracks",
  "originId":"Origin ID",
  "destinationId":"Destination ID",
  "destinationMachine": "Destination Machine",
  "positionId":"Position ID",
  "New track":"New track",
  "Edit track":"Edit track",
  "Add new position":"Add new position",
  "Minimum 2 characters to trigger filtering":"Type at least 2 characters to search",
  "New family":"New family",
  "Edit family":"Edit family",
  "Save":"Save",
  "Update":"Update",
  "New machine":"New machine",
  "Edit machine":"Edit machine",
  "machineId":"Machine ID",
  "Description":"Description",
  "skuFamilyId":"SKU family id",
  "skuFamilyDescription":"SKU family description",
  "MachineType":"Machine type",
  "RotationZone":"ABC categories",
  "Created":"Created",
  "RotationZones":"ABC categories",
  "RotationZoneId":"ABC category ID",
  "DangerIndicators":"Danger Indicators",
  "Edit dangerIndicator":"Edit danger indicator",
  "New dangerIndicator":"New danger indicator",
  "Danger Indicator deleted successfully":"Danger indicator deleted successfully",
  "Danger indicator added succefully":"Danger indicator added succesfully",
  "Are you sure you want to delete DangerIndicator %s ?":"Are you sure you want to delete the danger indicator {dangerIndicator}?",
  "Delete danger indicator":"Delete danger indicator",
  "Delete family":"Delete family",
  "Are you sure you want to delete family %s ?":"Are you sure you want to delete the family {family}?",
  "rotationZone added succesfully":"ABC category added succesfully",
  "rotationZone updated succesfully":"ABC category updated succesfully",
  "rotationZone delete successfully":"ABC category deleted succesfully",
  "Are you sure you want to delete rotationZone %s ?":"¿Are you sure you want to delete ABC category {rotationZone}?",
  "Are you sure you want to delete machine %s ?":"¿Are you sure you want to delte machine {machineName}?",
  "Machine added succefully":"Machine added succesfully",
  "Machine updated succefully":"Machine updated succesfully",
  "Machine delete successfully":"Machine deleted succesfully",
  "Delete machine":"Delete machine",
  "stock":"Stock",
  "palletId":"Pallet ID",
  "physicalPositionId":"Physical position ID",
  "cmPosition":"Cm position",
  "batchControl":"Batch Control",
  "clientCode":"Client Code",
  "expireControl":"Expire Control",
  "minimumUsefulLife":"Minimum Useful Life",
  "quarentineTime":"Quarantine Time",
  "rawMaterial":"Raw Material",
  "rawWeight":"Raw Weight",
  "serialControl":"Serial Control",
  "skuDescription":"SKU description",
  "skuId":"SKU ID",
  "skuShortDescription":"SKU Short Description",
  "stackable":"Stackable",
  "totalUsefulLife":"Total Useful Life",
  "weightControl":"Weight Control",
  "containerType":"Pallet Type ID",
  "dangerIndicator":"Danger Indicator ID",
  "family":"Family ID",
  "managmentMethodId":"Managed Method ID",
  "measurementUnit":"Measurement Unit ID",
  "minimumUsefulLifeTimeMeasurement":"Minimum Useful Life Time Measurements ID",
  "quarentineTimeMeasurement":"Quarantine Time Measurements ID",
  "rotationZone":"ABC category ID",
  "totalUsefulLifeTimeMeasurement":"Total Useful Life Time Measurements ID",
  "machineId":"Machine ID",
  "items":"Items",
  "New item":"New item",
  "Edit item":"Edit item",
  "updated":"Updated",
  "intermediateId":"Intermediate ID",
  "currentPositionId":"Current Position ID",
  "taskId":"Task ID",
  "movementType":"Movement type",
  "status":"Status",
  "IBOUND":"Inbound",
  "OUTBOUND":"Outbound",
  "RELOCATION":"Relocation",
  "RETURN_HOME":"Return to home",
  "PICKING":"Picking",
  "Inbound":"Inbound",
  "Outbound":"Outbound",
  "Relocation":"Relocation",
  "noDataAvailable":"No data available",
  "palletNumber":"Pallet number",
  "skuUnits":"SKU units",
  "expireDate":"Expire date",
  "send":"Save",
  "add":"Add",
  "addContainer":"Add container",
  "Add at least one item in the list":"Add at least one item in the list",
  "errorType":"Error type",
  "deleted":"Deleted",
  "RESTING":"Resting",
  "WAITING":"Waiting",
  "SENT":"Sent",
  "SUCCESS":"Success",
  "PENDING":"Pending",
  "PROCESSING": "In process",
  "ERROR":"Error",
  "COMPLETED":"Completed",
  "COMPLETED_MANUALLY":"Completed manually",
  "COMPLETED_WITH_ERRORS":"Completed with errors",
  "CANCELED":"Canceled",
  "REJECTED":"Rejected",
  "close":"Close",
  "Please enter a expire date":"Please enter a expire date",
  "noResults":"No results",
  "searchType":"Search type",
  "unitsRequested":"Units requested",
  "pickingZone":"PICKING zone",
  "high":"High",
  "medium":"Medium",
  "low":"Low",
  "Please input the pallet ID":"Please input the pallet ID",
  "Please input pallet number":"Please input pallet number",
  "Please select a pallet type":"Please select a pallet type",
  "Please enter units":"Please enter units",
  "Please select a SKU":"Please select a SKU",
  "Please select a position":"Please select a position",
  "Please select a machine":"Please select a machine",
  "inbound":"Inbound",
  "outbound":"Outbound",
  "relocation":"Relocation",
  "picking":"Picking",
  "INBOUND":"Inbound",
  "OUTBOUND":"Outbound",
  "RELOCATION":"Relocation",

  "totalQuantity":"Total quantity",
  "warehouseZone":"Warehouse zone",
  "Item added succefully":"Item added successfully",
  "Item updated succefully":"Item updated successfully",
  "Edit physicalPosition":"Edit physical position",
  "inboundLock":"Inbound lock",
  "exitLock":"Exit lock",
  "fullLock":"Full lock",
  "ExploitationCenter":"Exploitation center",
  "LocationType":"Location type",
  "AisleNumber":"Aisle number",
  "Laterality":"Laterality",
  "BayNumber":"Bay number",
  "LevelNumber":"Level number",
  "LocationCode":"Location code",
  "InUse":"In use",
  "ReservedEntrance":"Reserved entrance",
  "ReservedExit":"Reserved exit",
  "Side":"Side",
  "Bay":"Bay",
  "Level":"Level",
  "alternativeId":"Alternative ID",
  "superAdminLock":"Super admin lock",
  "generalLock":"General lock",
  "Position":"Position",
  "HUBMASTER - Location catalog":"HUBMASTER - Location catalog",
  "Select the block to apply in the location":"Select the block to apply in the location",
  "Indicate the reason for blocking the location":"Indicate the reason for blocking the location",
  "dateRange":"Date range",
  "depth":"Depth",
  "moreInfo":"More info",
  "quantity":"Quantity",
  "atHome":"Resting",
  "itemId":"Item ID",
  "managementMethod":"Rotation method",
  "outboundLock":"Outbound lock",
  "totalUsefulLifeTimeMeasurement":"Total useful lifetime measurement",
  "requiredfield":"Required field",
  "visibleComlumns":"Visible columns",
  "frontOverhang":"Front overhang",
  "backOverhang":"Back overhang",
  "rejectReasonCode":"Reject reason code",
  "monday":"Monday",
  "tuesday":"Tuesday",
  "wednesday":"Wednesday",
  "thursday":"Thursday",
  "friday":"Friday",
  "saturday":"Saturday",
  "sunday":"Sunday",
  "stockExcel":"Inventory Alignment",
  "compactionHm1":"Compaction HM1",
  "compactionHm2":"Compaction HM2",
  "compactionHm3":"Compaction HM3",
  "rotationZoneAssignment":"Rotation zone assignment",
  "photostock":"Photostock",
  "tasks":"Tasks",
  "update":"Update",
  "disabled":"Disabled",
  "enabled":"Enabled",
  "taskLog":"Task Log",
  "taskName":"Task Name",
  "stop":"Stop",
  "finished":"Finished",
  "working":"Working",
  "Lock position updated succefully":"Lock position updated successfully",
  "Reason is required":"Reason is required",
  "Alarms":"Alarms",
  "alarmId":"Alarm ID",
  "alarmStatus":"Alarm status",
  "alarmName":"Alarm name",
  "problemDescription":"Problem description",
  "created":"Created",
  "deleted":"Deleted",
  "Alarm Update Succesfully":"Alarm updated successfully",
  "Active":"Active",
  "Solved":"Solved",
  "block":"block",
  "blockPositionType":"block position type",
  "stockRemove":"Remove confirmation",
  "You confirm that pallet with ID {palletId} is no longer in location {physicalPositionId}?":"You confirm that pallet with ID {palletId} is no longer in location {physicalPositionId}?",
  "serverTime":"Server local date time",
  "viewBlock":"Display block positions",
  "alternativeId":"Alternative ID",
  "Select Positions":"Select Positions",
  "Block Positions":"Block",
  "Unblock Positions":"Unblock",
  "Select Positions":"Select Positions",
  "Block Positions":"Block Positions",
  "Unblock Positions":"Unblock Positions",
  "Selected Positions:":"Selected Positions:",
  "Select Block Type":"Select Block Type",
  "Please provide necessary data":"Please provide necessary data",
  "Cancel":"Cancel",
  "Are you sure you want to unblock the following positions?":"Are you sure you want to unblock the following positions?",
  "Positions blocked successfully":"Positions blocked successfully",
  "Error blocking positions":"Error blocking positions",
  "Positions unblocked successfully":"Positions unblocked successfully",
  "Error unblocking positions":"Error unblocking positions",
  "Blocked Positions":"Blocked Positions",
  "Unlocked positions":"Unlocked positions",
  "All positions":"All positions",
  "Please provide both block type and reason":"Please provide both block type and reason",
  "Lock removed successfully":"Lock removed successfully",
  "kpisDashboard":"KPI dashboard",
  "Total Inbounds Today":"Total Inbounds Today",
  "Total Outbounds Today":"Total Outbounds Today",
  "Error Types":"Error Types",
  "Total Errors in Inbounds and Outbounds Today":"Total Errors in Inbounds and Outbounds Today",
  "Kpi's Dashboard":"KPI dashboard",
  "Dashboard":"Dashboard",
  "movementsKpi":"Movement duration",
  "totalMovements":"Total Movements",
  "movementsPerHour":"Movements per Hour",
  "movementsPerDay":"Movements per Day",
  "averageMovementTime":"Average Movement Time",
  "movementsByType":"Movements by Type",
  "movementsByMachine":"Movements by Machine",
  "movementsByZone":"Movements by Zone",
  "inboundMovements":"Inbound Movements",
  "outboundMovements":"Outbound Movements",
  "internalMovements":"Internal Movements",
  "rotationMovements":"Rotation Movements",
  "machineEfficiency":"Machine Efficiency",
  "pendingMovements":"Pending Movements",
  "completedMovements":"Completed Movements",
  "inProgressMovements":"In Progress Movements",
  "cancelledMovements":"Cancelled Movements",
  "averageCycleTime":"Average Cycle Time",
  "movementsTrend":"Movements Trend",
  "sinceLastPeriod":"since last period",
  "pending":"Pending",
  "completed":"Completed",
  "inProgress":"In Progress",
  "cancelled":"Cancelled",
  "No data available":"No data available",
  "Movements":"Movements",
  "delete":"Delete",
  "edit":"Edit",
  "positionType":"Position type",
  "out":"Out",

  "New Alarm Detected!":"New Alarm Detected!",
  "Enter the destination location where you want to place this pallet":"Enter the destination location where you want to place this pallet",
  "Are you sure you want to delete movement with palleId %s?":"Are you sure you want to delete the movement with palletId {palletId}?",
  "Are you sure you want to finish movement with palleId %s?":"Are you sure you want to finish the movement with palletId {palletId}?",
  "The movement will be deleted":"The movement will be deleted and the pallet will remain in its original position. If this is an inbound movement, the pallet will not be stored in the warehouse.",
  "The movement will be completed":"The movement will be completed to the destination position. If this is an outbound movement, the pallet will be removed from the warehouse.",
  "Delete movement":"Delete movement",
  "Minimize":"Minimize",
  "Maximize":"Maximize",
  "TOTAL INBOUNDS":"Total inbounds",
  "Total Inbounds":"Total inbounds",
  "Today":"Today",
  "Hours":"Hours",
  "Daily":"Daily",
  "Weekly":"Weekly",
  "Monthly":"Monthly",
  "Average Inbounds per":"Average Inbounds per",
  "Average Errors per":"Average Errors per",
  "Hour":"Hour",
  "Day":"Day",
  "Monday":"Monday",
  "Tuesday":"Tuesday",
  "Wednesday":"Wednesday",
  "Thursday":"Thursday",
  "Friday":"Friday",
  "Saturday":"Saturday",
  "Sunday":"Sunday",
  "Week":"Week",
  "Month":"Month",
  "Inbounds":"Inbounds",
  "Close":"Close",
  "alternativeTypeNumber":"WMS pallet type ID",
  "January":"January",
  "February":"February",
  "March":"March",
  "April":"April",
  "May":"May",
  "June":"June",
  "July":"July",
  "August":"August",
  "September":"September",
  "October":"October",
  "November":"November",
  "December":"December",
  "repeatCurrentStep":"Repeat current step",
  "You confirm that you want to repeat the current step with pallet ID: {palletId}?":"You confirm that you want to repeat the current step with pallet ID: {palletId}?",
  "Outbounds":"Outbounds",
  "TOTAL OUTBOUNDS":"Total outbounds",
  "Total Outbounds":"Total outbounds",
  "Average Outbounds per":"Average Outbounds per",
  "Priority":"Priority",
  "userId":"User ID",
  "name":"Name",
  "username":"Username",
  "rol":"Role",
  "editUser":"Edit user",
  "password":"Password",
  "repeatPassword":"Repeat password",
  "Are you sure you want to delete {name}?":"Are you sure you want to delete {name}?",
  "deleteUser":"Delete user",
  "User {name} deleted":"User {name} deleted",
  "params":"Parameters",
  "search":"Search",
  "new":"New",
  "edit":"Edit",
  "delete":"Delete",
  "editParam":"Edit param",
  "newParam":"New param",
  "key":"Key",
  "value":"Value",
  "pleaseEnterKey":"Please enter a key",
  "pleaseEnterValue":"Please enter a value",
  "update":"Update",
  "save":"Save",
  "actions":"Actions",
  "id":"ID",
  "added":"added",
  "successfully":"successfully",
  "deleteParam":"Delete param",
  "areYouSureDeleteParam":"Are you sure you want to delete param {key}?",
  "deletedSuccessfully":"deleted successfully",
  "logger":"Logger",
  "applicationLogs":"Application Logs",
  "systemLogs":"System logs",
  "selectLogFile":"Select file",
  "refresh":"Refresh",
  "thread":"Thread",
  "class":"Class",
  "Error loading system logs":"Error loading system logs",
  "close":"Close",
  "search":"Search",
  "user":"User",
  "searchByMessage":"Search by message",
  "dataTime":"Data time",
  "level":"Level",
  "message":"Message",
  "installationName":"Installation name",
  "hmWareUrl":"Hmware url",
  "cmLogicUrl":"Cmlogic Url",
  "cmLogicUser":"Cmlogic user",
  "cmLogicPassword":"Cmlogic password",
  "wmsUrl":"WMS URL",
  "wmsUser":"WMS user",
  "wmsPassword":"WMS password",
  "imagesPath":"Images path",
  "analyticsUrl":"Analytics URL",
  "update":"Update",
  "required":"Required",
  "updatedSuccessfully":"Updated successfully",
  "TOTAL ERRORS":"TOTAL ERRORS",
  "Errors Type":"Error type",
  "Errors":"Errors",
  "Warehouse Occupancy":"Warehouse Occupancy",
  "Free":"Free",
  "Occupied":"Occupied",
  "Occupied positions":"Occupied positions",
  "completed":"Completed",
  "takeOutStock":"Take out stock",
  "No data available today":"No data available today",
  "Average Activity":"Average Activity",
  "Average Real-Time Activity per Machine":"Average real-time activity per machine",
  "Activity":"Activity",
  "stockAdjustment":"Stock adjustment",
  "inqueue":"This pallet is possibly in the movement queue",
  "batchNumber":"Lot number",
  "warehouseViewer":"Warehouse viewer",
  "priority":"Priority",
  "removalEmptyPallets":"Removal empty pallets",
  "newUser":"New user",
  "Select Block Depth":"Select Block Depth",
  "Only depth 2":"Only second depth",
  "All depths":"All depths",
  "Some positions were excluded as they do not have Second Depth":"Some positions were excluded as they do not have Second Depth",
  "Please input pallet weight":"Please input pallet weight",
  "Please input pallet height":"Please input pallet height",
  "allowedItems":"Allowed items",
  "legendEmpty":"Free position",
  "legendFull":"Occupied position",
  "legendEmptyLocked":"Locked free position",
  "legendFullLocked":"Locked occupied position",
  "legendInstructions":"To view the details of a position in the image, hover over it and double-click. If you want to rotate the image, click and drag the left mouse button in the desired direction. To move the image, hold down the right mouse button while moving the cursor.",
  "visibleLabels":"Bay labels visible",
  "inventoryBalance":"Inventory Balance",
  "Free positions":"Free positions",
  "runNow":"Run now",
  "serialNumber":"Serial number",
  "families":"Families",
  "nextStep":"Next step",
  "You confirm that current step is complete and run next step: {palletId}?":"You confirm that current step is complete and run next step: {palletId}?",
  "download":"Download",
  "pause":"Pause",
  "cameras":"Cameras",
  "inventoryProcess":"Inventory process",
  "inventoryRequest":"Inventory request",
  "inventoryType":"Inventory type",
  "photo_counting":"Photo counting",
  "inventory_counting": "Inventory Counting",
  "viewPhoto":"View photo",
  "pending_return":"Pending return",
  "You confirm that the following pallet doesn't exist: {palletId}?":"You confirm that the following pallet doesn't exist: {palletId}?",
  "inventory":"Inventory",
  "showLive": "Show live",
  "AVERAGE INBOUNDS PER HOUR":"AVERAGE INBOUNDS PER HOUR",
  "Average Inbounds per Hour":"Average Inbounds per Hour",
  "Error fetching data":"Error fetching data",
  "Average Inbounds":"Average Inbounds",
  "Failed to load data":"Failed to load data",
  "Average":"Average",
  "AVERAGE OUTBOUNDS PER HOUR":"AVERAGE OUTBOUNDS PER HOUR",
  "Average Outbounds per Hour":"Average Outbounds per Hour",
  "Average Outbounds":"Average Outbounds",
  "TOTAL NUMBER OF REJECTED PALLETS":"TOTAL NUMBER OF REJECTED PALLETS",
  "Pallets Rejected":"Pallets Rejected",
  "Total Number of Rejected": "Total Number of Rejected",
  "since last month":"since last month",
  "palletHeight": "Pallet height",
  "palletWidth": "Pallet width",
  "palletWeight": "Pallet weight",
  "palletDepth": "Pallet depth",
  "palletHeightCm": "Pallet height (mm)",
  "palletWidthCm": "Pallet width (mm)",
  "palletWeightKg": "Pallet weight (kg)",
  "palletDepthCm": "Pallet depth (mm)",
  "machine": "Machine",
  "valueMustBeGreaterAndLessThan": "Value must be greater than {min} and less than {max}",
  "nextStep":"Next step",
  "You confirm that current step is complete and run next step: {palletId}?":"You confirm that current step is complete and run next step: {palletId}?",
  "download": "Download",
  "PAUSE": "Pause",
  "movSubType": "Movement subtype",
  "CANCELED": "Canceled",
  "SUSPENDED": "Suspended",
  "PICK_STATION": "Pick station",
  "PICK_RACK":"Pick rack",
  "DROP_STATION":"Drop station",
  "DROP_RACK":"Drop rack",
  "INVENTORY":"Inventory",
  "DROP_GRAVITY_OUT":"Drop gravity out",
  "CONVEYOR":"Conveyor",
  "SHUTTLE":"Shuttle",
  "CONVEYOR_DS":"Conveyor DS",
  "Are you sure the pallet is there?" : "Are you sure the pallet is there? ",
  "conveyor side": "Conveyor side",
  "systemSelected":"System selected",
  "system1":"Hubmaster 1",
  "system2":"Hubmaster 2",
  "system3":"Hubmaster 3",
  "cancelInventoryProcess": "Cancel Inventory Process",
  "areYouSureInventoryProcess": "Are you sure you want to cancel the inventory process?",
  "inventoryProcessCanceled": "Inventory process CANCELED",
  "TotalInboundsMoreInfo":"This shows the total number of goods received registered in the warehouse during the selected period. The arrow shows the trend compared to the previous period.",
  "TotalOutboundsMoreInfo":"This shows the total number of goods dispatched from the warehouse during the selected period. The arrow shows the trend compared to the previous period.",
  "TotalErrorsMoreInfo":"This shows the total number of errors that occurred during inbound and outbound operations in the warehouse during the selected period. The arrow shows the trend compared to the previous period.",
  "ErrorsTypeMoreInfo":"This donut chart breaks down the total errors by category or type, allowing you to quickly identify the most common causes of operational failures.",
  "RejectReasonsMoreInfo":"This donut chart shows the reasons why items were rejected during inbound or outbound operations, helping to identify patterns and improve process quality.",
  "WarehouseOccupancyMoreInfo":"This shows the percentage of occupied positions in the warehouse compared to the total number of positions. The arrow indicates the trend compared to the previous period.",
  "AverageActivityMoreInfo":"This shows the average activity of the machines in the warehouse during the selected period. The arrow indicates the trend compared to the previous period.",
  "delete movement":"Delete movement",
  "Confirm and place pallet":"Confirm and place pallet",
  "Running": "Running",
  "Finish movement":"Finish movement",
  "Confirm all active alarms": "Confirm all active alarms",
  "videos": "Videos",
  "Terminal":"Terminal",
  "noMatchesFound":"No matches found",
  "Confirm":"Confirm",
  "Are you sure you want to confirm all active alarms? This action cannot be undone.": "Are you sure you want to confirm all active alarms?",
  "All active alarms confirmed successfully.": "Alarms confirmed successfully",
  "No active alarms to confirm.": "No active alarms to confirm",
  "charts": "Charts",
  "outbound": "outbound",
  "inbound": "inbound",
  "lock": "lock",
  "lock_reason": "lock reason",
  "unlock": "unlock",
  "yes": "yes",
  "no": "no",
  "cancel": "cancel",
  "help": "help",
  "occupation": "occupation",
  "All":"All",
  "today":"Today",
  "last7days":"Last 7 days",
  "last30days":"Last 30 days",
  "accessDenied": "You do not have permission to access this page. Please contact your administrator.",
  "systemLogs":"System logs",
  "logFile":"Log file",
  "fromDate":"From date",
  "toDate":"To date",
  "searchInTrace":"Search in trace",
  "dateTime":"Date Time",
  "logType":"Type",
  "class":"Class",
  "trace":"Trace",
  "refresh":"Refresh",
  "typeFilter":"Filter by type",
  "movements":"Movements",
  "Hour":"Hour",
  "Movement Time (Minutes)": "Movement Time (Minutes)",
  "Days": "Days",
  "Weeks": "Weeks",
  "Average Movement Time": "Average Movement Time",
  "Day": "Day",
  "Week": "Week",
  "Capacity per Hour": "Capacity per Hour",
  "Movements per Hour": "Movements per Hour",
  "All Movements": "All Movements",
  "No results": "No results",
  "Outlier": "Outlier",
  "Movement Type": "Movement Type",
  "Process duration": "Process duration",
  "Status": "Status",
  "per Machine": "per Machine",
  "Avg Movement Duration Trend": "Avg Movement Duration Trend",
  "Registered movements": "Registered movements",
  "Picking": "Picking",
  "An unexpected error occurred": "An unexpected error occurred",
  "Error loading data": "Error loading data",
  "Minutes": "Minutes",
  "Total Errors": "Total Errors",
  "Reject Reasons": "Rejection reasons",
  "Average Real-Time Activity": "Average real-time activity",
    "uptimeKpi":"Uptime KPI",
  "maintenanceResponse":"Maintenance response",
  "primaryKpi":"Primary KPI",
  "totalTime":"Total time",
  "stoppedTime":"Downtime",
  "detailedAnalysisBySystem":"Detailed analysis by system",
  "HourlyViewSingleDaySelected":"Hourly view – single day selected",
  "DailyViewMultipleDaysSelected":"Daily view – multiple days selected",
  "uptime":"Uptime",
  "FaultTime":"Fault time",
  "AcknowledgmentTime":"Acknowledgment time",
  "RepairTime":"Repair time",
  "ResolutionTime":"Resolution time",
  "Fault occurrence time → Maintenance acknowledgment time":"Fault occurrence time → Maintenance acknowledgment time",
  "Maintenance acknowledgment time → Maintenance resolution time":"Maintenance acknowledgment time → Maintenance resolution time",
  "Fault occurrence time → Maintenance resolution time":"Fault occurrence time → Maintenance resolution time",
  "avg":"Average",
  "minimum":"Minimum",
  "maximum":"Maximum",
  "DowntimeAndErrorsPerDay":"Downtime and errors per day",
  "DowntimeAndErrorCountPerDay":"Downtime and error count per day",
  "DowntimeAndErrorCountPerHour":"Downtime and error count per hour",
  "downtime":"Downtime",
  "errorCount":"Error count",
  "AverageEvolutionOfResponseTime":"Average evolution of response time",
  "TrendInMaintenanceTimes":"Trend in maintenance times",
  "acknowledgmentTime":"Acknowledgment time",
  "resolutionTime":"Resolution time",
  "ErrorBreakdown":"Error breakdown",
  "DetailedHistoryOfFailuresAndResponseTimes":"Detailed history of failures and response times",
  "system":"System",
  "occurrence":"Occurrence",
  "repairTime":"Repair time",
  "reactionTime":"Reaction time",
  "time":"Time",
  "resolved":"Resolved",
  "TotalErrors":"Total errors",
  "InSelectedPeriod":"In selected period, the sum of errors of all systems",
  "TotalDowntime":"Total downtime",
  "HourlyAverage":"Hourly average",
  "DailyAverage":"Daily average",
  "ErrorsPerHour":"Errors per hour of all systems",
  "ErrorsPerDay":"Errors per day of all systems",
  "activeTasks":"Active tasks",
  "An unexpected error occurred":"An unexpected error occurred",
  "recoveryTime":"Recovery time",
  "cumulativeTotal":"Cumulative total",
  "Total downtime":"Total downtime",
  "Maintenance response time":"Maintenance response time",
  "Maintenance acknowledgment time → Maintenance arrival time":"Maintenance acknowledgment time → Maintenance arrival time",
  "Maintenance arrival time → Maintenance resolution time":"Maintenance arrival time → Maintenance resolution time",
  "notResolved":"Not resolved",
  "maxDaysMachineStopped":"{days} days since machines stopped",
  "SumOfTheTimeOfAllSystems":"Sum of the time of all systems",
  "Pallet Type / Height":"Pallet type / height",
  "Registered movements":"Registered movements",
  "Error loading data":"Error loading data",
  "Avg Movement Duration Trend":"Avg Movement Duration Trend",
  "Days":"Days",
  "Weeks":"Weeks",
  "Minutes":"Minutes",
  "capacityDashboard":"Warehouse capacity",
  "Generate inbound":"Auto-generate inbound",
  "Generate outbound":"Auto-generate outbound",
  "numberOfPallets":"Number of pallets",
  "generate":"Generate",
  "generateInboundDescription":"Generates {count} random inbound movements for demo.",
  "generateOutboundDescription":"Generates {count} random outbound movements for demo. Optionally filter by SKU.",
  "Height":"Height",
  "Total positions":"Total positions",
  "positions":"positions",
  "heightChartTitle":"Height {letter} ({height} {unit})",
  "totalPositionsLabel":"Total positions:",
  "noFreePositions":"No free positions",
  "metricSystem": "Metric system",
  "metricSystemIS": "International System (mm, kg)",
  "metricSystemUSCS": "US Customary System (in, lb)",
  "weight":"Weight",
  "analyticsUser":"Analytics user",
  "analyticsPassword":"Analytics password",
  "localhostIp":"Localhost IP",
  "returnToHomeDelay":"Return-to-home delay (seconds; 0 = disabled)",
  "newInbound":"New inbound",
  "newOutbound":"New outbound",
  "None":"None",
  "ROLE_ADMIN":"Administrator",
  "ROLE_COMMUNICATION":"Communication",
  "ROLE_WMS":"WMS",
  "ROLE_SUPERADMIN":"Super administrator",
  "ROLE_USER":"User",
  "ROLE_ENGINEERING":"Engineering",
  "ROLE_MAINTENANCE":"Maintenance",
  "Orders queue":"Order queue",
  "Orders history":"Order history",
  "Pallets measures":"Pallet measurements",
  "PLC params":"PLC parameters",
  "Acquisition (PPA)":"Point cloud acquisition (PPA)",
  "System Logs":"System logs",
};
